<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <nav aria-label="breadcrumb mb-0">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a class="screen-reader" routerLink="/">{{ 'Home' | translate }}</a></li>
                <li class="breadcrumb-item"><a class="screen-reader" routerLinkActive="active-nemu" routerLink="/tender">{{ 'Tenders' |  translate}}</a></li>
                <li class="breadcrumb-item"><a class="active-nemu screen-reader"
                        routerLink="/tender-details/{{ encode(tender_id) }}">{{ 'TenderDetails' | translate}}</a></li>
            </ol>
        </nav> 
    </div>
    <!-- BREADCRUMB AREA - ENDS -->

    <div class="inner-page">
        <div class="inner-page-details">
            <div class="row">

                <div class="col-lg-12">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between mb-0">
                                        <h2 class="screen-reader">{{ 'TenderDetails' | translate}}</h2>
                                    </div>
                                    <div class="description mt-0">
                                        <div class="tenders">
                                            <div class="row">
                                                <div class="col-lg-12">

                                                    <!-- tender details section area - starts -->

                                                    <div class="tender-details-area">
                                                        <div class="region">
                                                            <div class="d-flex align-items-center">
                                                                <div class="d-block d-sm-flex gap-3">
                                                                    <div class="fs-5 fw-bold text-orange screen-reader"> <i
                                                                            class="bi bi-geo-alt me-1"></i>
                        <span 
                        title="Zone">
                        {{ getZoneNameEnHn(tender_Details.zone) }} ,</span>
                        <span title="Region">  {{ getregionNameEnHn(tender_Details.region) }}
                    
                    </span>
                                                                    </div>
                                                                    <div class="zone-sec screen-reader" title="ID"> <b> {{ tender_Details.tenderNumber }}</b>
                                                                    </div>
                                                                </div>
                                                                <!-- <div class="zone-sec d-flex">
                                                                    <div class="custom-border-end pe-3">
                                                                        <h6>Zone : <span class="badge bg-success"> {{
                                                                                jsonConvert(tender_Details,'ZONE_ID')}}</span>
                                                                        </h6>
                                                                    </div>
                                                                    <div class="pdf-links">
                                                                        <h6>Region : <span class="badge bg-success">{{
                                                                                jsonConvert(tender_Details,'REGION_ID')}}</span>
                                                                        </h6>
                                                                        <a href="javascript:;" class="me-3"
                                                                            title="The pdf file will open in new window"><i
                                                                                class="bi-file-earmark-pdf me-1"></i>WHEAT
                                                                            <small>(pdf - 1,169 Kb)</small></a>
                                                                        <a href="javascript:;" class=""
                                                                            title="The pdf file will open in new window"><i
                                                                                class="bi-file-earmark-pdf me-1"></i>RICE
                                                                            <small>(pdf - 1,169 Kb)</small></a>
                                                                    </div>
                                                                </div> -->
                                                            </div>
                                                            <!-- <div>
                                                                <a [href]="backend_url+'storage/app/uploads/'+tender_Details.uploadDocument"
                                                                    [download]="tender_Details.uploadDocument"
                                                                    title="{{ tender_Details.title}}" target="_blank"
                                                                    class="btn btn-sm btn-outline-success"
                                                                    title="Download PDF"><i
                                                                        class="bi bi-file-earmark-pdf me-2"></i>Download</a>
                                                            </div> -->
                                                        </div>
                                                        <div class="tender-title">
                                                            <h4 class="screen-reader" id="tenderTbale">{{ htmlTag(language=='English'?tender_Details.title:tender_Details.titleInHindi)}}</h4>
                                                        </div>
                                                        <div class="tender-desc content-details">
                                                            <p class="screen-reader font-adjust" [innerHTML]="htmlTag(language=='English'?tender_Details.description:tender_Details.descriptionInHindi)">
                                                            </p>
                                                        </div>
                                                        <div class="note-dates d-sm-flex align-items-center mt-0">
                                                            <div class="d-flex gap-2 align-items-center flex-wrap">
                                                                <!-- <div class="opening-date" *ngIf="tender_Details.publishDate!=='1000-01-01'">
                                                                    <strong class="d-block text-green">
                                                                        <span class="me-2 screen-reader"> <i
                                                                                class="bi bi-calendar3 me-1"></i> {{
                                                                            tender_Details.publishDate | date: 'MMM d, y'}}</span>
                                                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>{{
                                                                            tender_Details.publishTime | timeFormat}}</span>
                                                                    </strong>
                                                                    <span class="labels text-muted screen-reader">{{ 'FloatDateTime' | translate}}</span>
                                                                </div> -->
                                                                <!-- <div class="opening-date" *ngIf="tender_Details.closingDate!=='1000-01-01'">
                                                                    <strong class="d-block text-red">
                                                                        <span class="me-2 screen-reader"> <i
                                                                                class="bi bi-calendar3 me-1"></i> {{
                                                                            tender_Details.closingDate | date: 'MMM d, y'}}</span>
                                                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i> {{
                                                                            tender_Details.closingTime | timeFormat}}</span>
                                                                    </strong>
                                                                    <span class="labels text-muted screen-reader">{{ 'ExpiryDateTime' | translate}}</span>
                                                                </div> -->
                                                               
                                                                <div class="opening-date font-adjust" *ngIf="tender_Details.bidOpeningDate!=='1000-01-01'">
                                                                    <strong class="d-block txt-black">
                                                                        <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>
                                                                            {{ tender_Details.bidOpeningDate | date: 'MMM d, y'}}
                                                                            </span>
                                                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                                            {{ tender_Details.bidOpeningTime | timeFormat}}
                                                                        </span>
                                                                    </strong>
                                                                    <span class="labels text-muted screen-reader">{{ 'BidOpeningDate' | translate}}</span>
                                                                </div>
                                                                <div class="opening-date font-adjust" *ngIf="tender_Details.bidSubmissionStartDate!=='1000-01-01'">
                                                                    <strong class="d-block txt-black">
                                                                        <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>
                                                                            {{ tender_Details.bidSubmissionStartDate | date: 'MMM d, y'}}
                                                                            </span>
                                                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                                            {{ tender_Details.bidSubmissionStartTime | timeFormat}}
                                                                        </span>
                                                                    </strong>
                                                                    <span class="labels text-muted screen-reader">{{ 'BidSubmissionStartDate' | translate}}
                                                                    </span>
                                                                </div>
                                                                <div class="opening-date font-adjust" *ngIf="tender_Details.bidSubmissionEndDate!=='1000-01-01'">
                                                                    <strong class="d-block txt-black">
                                                                        <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>
                                                                            {{ tender_Details.bidSubmissionEndDate | date: 'MMM d, y'}}
                                                                            </span>
                                                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                                            {{ tender_Details.bidSubmissionEndTime | timeFormat}}
                                                                        </span>
                                                                    </strong> 
                                                                    <span class="labels text-muted screen-reader">{{ 'BidSubmissionEndDate' | translate}}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </div>


                                                        <div class="col-md-12 mt-3 mb-3">
                                                            <div class="table-responsive font-adjust">
                                                                <table class="table table-hover" aria-describedby="tenderTbale">
                                                                    <thead>
                                                <tr>
                                                    <th class="screen-reader">#</th>
                                                    <!-- <th class="screen-reader">{{ 'DocumentType' | translate}}</th> -->
                                                    <th class="screen-reader">{{ 'DocumentName' | translate}}</th>
                                                    <th class="text-end screen-reader">{{ 'DocumentSize' | translate}}</th>
                                                    <th class="text-center screen-reader">{{ 'Download' | translate}}</th>
                                                </tr>
                                                                    </thead>
                                    <tbody>
 
                                        <tr *ngFor="let f of Files_(tender_Details.uploadDocument); let x = index;">
                                            
                                            <td class="screen-reader">{{ x+1 }}</td>
                                            <!-- <td class="screen-reader">{{ f.fileType }}</td> -->
                                            <td class="screen-reader">{{ (language=='English') ? htmlTag(f.fileTitle) : htmlTag(f.fileTitleInHindi)}}</td>
                                            <td class="text-end screen-reader">
                                                {{ f.selectFIle_details.fileSize }} 
                                                <span style="text-transform: uppercase;" *ngIf="checkFileType(f)!==false" [innerHtml]="checkFileType(f).file"></span>
                                                {{f.dtmCreatedOn | date:'MMM d, y'}}
                                            </td>
                                            <td class="text-center screen-reader">
                                                <strong class="d-block">
                                                    <a target="_blank" [href]="backend_url+'storage/app/uploads/'+f.selectFIle" title="{{ f.fileType}}" class="text-green"  [download]="f.selectFIle"><span class="me-2"> <i
                                                            class="bi bi-download me-1"></i> </span></a>
                                                </strong>
                                                <!-- <span class="labels text-muted">({{ f.selectFIle_details.fileSize }}) </span> -->
                                            </td>
                                        </tr>
                                        
                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>




                        <div class="other-documents" *ngIf="has_Addendum_Details">
                            <h5 class="screen-reader" id="addenTable">{{ 'AddendumDetails' |  translate}}</h5>

                        <div *ngFor="let a of Addendum_Details;">
                            <div class="note-dates d-sm-flex align-items-center ">
                                <div class="d-flex gap-2 align-items-center flex-wrap">
                                    <!-- <div class="opening-date" *ngIf="a.publishDate!=='1000-01-01'">
                                        <strong class="d-block text-green">
                                                <span class="me-2 screen-reader"> 
                                                    <i class="bi bi-calendar3 me-1"></i> 
                                                    {{  a.publishDate | date: 'MMM d, y'}}
                                                </span>
                                                <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                    {{a.publishTime | timeFormat}}
                                                </span>
                                        </strong>
                                        <span class="labels text-muted screen-reader">{{ 'FloatDateTime' | translate}}</span>
                                    </div> -->
                                    <!-- <div class="opening-date" *ngIf="a.closingDate!=='1000-01-01'">
                                        <strong class="d-block text-red">

                                            <span class="me-2 screen-reader"> 
                                                <i class="bi bi-calendar3 me-1"></i> 
                                                {{a.closingDate | date: 'MMM d, y'}}
                                            </span>
                                            <span class="screen-reader"> 
                                                <i class="bi bi-clock me-1"></i> 
                                                {{ a.closingTime | timeFormat}}
                                            </span>

                                        </strong>
                                        <span class="labels text-muted screen-reader">{{ 'ExpiryDateTime' | translate}}</span>
                                    </div> -->
                                
                                    <div class="opening-date font-adjust" *ngIf="a.bidOpeningDate!=='1000-01-01'">
                                        <strong class="d-block txt-black">
                                            <span class="me-2 screen-reader"> 
                                                <i class="bi bi-calendar3 me-1"></i>
                                                {{ a.bidOpeningDate | date: 'MMM d, y'}}
                                                </span>
                                            <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                {{ a.bidOpeningTime | timeFormat}}
                                            </span>
                                        </strong>
                                        <span class="labels text-muted screen-reader">{{ 'BidOpeningDate' | translate}}</span>
                                    </div>
                                    <div class="opening-date font-adjust" *ngIf="a.bidSubmissionStartDate!=='1000-01-01'">
                                        <strong class="d-block txt-black">
                                            <span class="me-2 screen-reader"> 
                                                <i class="bi bi-calendar3 me-1"></i>
                                                {{ a.bidSubmissionStartDate | date: 'MMM d, y'}}
                                                </span>
                                            <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                {{ a.bidSubmissionStartTime | timeFormat}}
                                            </span>
                                        </strong>
                                        <span class="labels text-muted screen-reader">{{ 'BidSubmissionStartDate' | translate}}
                                        </span>
                                    </div>
                                    <div class="opening-date font-adjust" *ngIf="a.bidSubmissionEndDate!=='1000-01-01'">
                                        <strong class="d-block txt-black">
                                            <span class="me-2 screen-reader"> 
                                                <i class="bi bi-calendar3 me-1"></i>
                                                {{ a.bidSubmissionEndDate | date: 'MMM d, y'}}
                                                </span>
                                            <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                                {{ a.bidSubmissionEndTime | timeFormat}}
                                            </span>
                                        </strong> 
                                        <span class="labels text-muted screen-reader">{{ 'BidSubmissionEndDate' | translate}}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="table-responsive font-adjust">
                                <table class="table table-hover" aria-describedby="addenTable">
                                    <thead>
                                        <tr>
                                            <th class="screen-reader">#</th>
                                            <!-- <th class="screen-reader">{{ 'DocumentType' | translate}}</th> -->
                                            <th class="screen-reader">{{ 'DocumentName' | translate}}</th>
                                            <th class="text-end screen-reader">{{ 'DocumentSize' | translate}}</th>
                                            <th class="text-center screen-reader">{{ 'Download' | translate}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr *ngFor="let z of Files_(a.uploadDocument); let x = index;">
                                            <td class="screen-reader">{{ x+1 }}</td>
                                            <!-- <td class="screen-reader">{{ z.fileType }}</td> -->
                                            <td class="screen-reader">{{ (language=='English') ? htmlTag(z.fileTitle) : htmlTag(z.fileTitleInHindi)}}</td>
                                            <td class="text-end screen-reader">
                                                {{ z.selectFIle_details.fileSize }}
                                                <span style="text-transform: uppercase;" *ngIf="checkFileType(z)!==false" [innerHtml]="checkFileType(z).file"></span>
                                                {{z.dtmCreatedOn | date:'MMM d, y'}}
                                            </td>
                                            <td class="text-center screen-reader">
                                                <strong class="d-block">
                                                    <a target="_blank" [href]="backend_url+'storage/app/uploads/'+z.selectFIle" title="{{ z.fileType}}" class="text-green"  [download]="z.selectFIle"><span class="me-2"> <i
                                                            class="bi bi-download me-1"></i></span></a>
                                                </strong>
                                                <!-- <span class="labels text-muted">({{ z.selectFIle_details.fileSize }}) </span> -->
                                            </td>
                                        </tr>
                                       
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        </div>







            <div class="other-documents" *ngIf="has_Corrigendum_Details">
                        <h5 class="screen-reader" id="corrigTable">{{ 'CorrigendumDetails' |  translate}}</h5>
                <div *ngFor="let c_d of Corrigendum_Details;">
                        <div class="note-dates d-sm-flex align-items-center">
                            <div class="d-flex gap-2 align-items-center flex-wrap">
                                <!-- <div class="opening-date" *ngIf="c_d.publishDate!=='1000-01-01'">
                                    <strong class="d-block text-green">
                                        <span class="me-2 screen-reader"> 
                                            <i class="bi bi-calendar3 me-1"></i> {{ c_d.publishDate | date: 'MMM d, y'}}
                                        </span>
                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>{{
                                            c_d.publishTime | timeFormat}}</span>
                                    </strong>
                                    <span class="labels text-muted screen-reader">{{ 'FloatDateTime' | translate}}</span>
                                </div> -->
                                <!-- <div class="opening-date" *ngIf="c_d.closingDate!=='1000-01-01'">
                                    <strong class="d-block text-red">
                                        <span class="me-2 screen-reader"> <i
                                                class="bi bi-calendar3 me-1"></i> {{
                                                    c_d.closingDate | date: 'MMM d, y'}}</span>
                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i> {{
                                            c_d.closingTime | timeFormat}}</span>
                                    </strong>
                                    <span class="labels text-muted screen-reader">{{ 'ExpiryDateTime' | translate}}</span>
                                </div> -->
                               
                                <div class="opening-date font-adjust" *ngIf="c_d.bidOpeningDate!=='1000-01-01'">
                                    <strong class="d-block txt-black">
                                        <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>
                                            {{ c_d.bidOpeningDate | date: 'MMM d, y'}}
                                            </span>
                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                            {{ c_d.bidOpeningTime | timeFormat}}
                                        </span>
                                    </strong>
                                    <span class="labels text-muted screen-reader">{{ 'BidOpeningDate' | translate}}</span>
                                </div>
                                <div class="opening-date font-adjust" *ngIf="c_d.bidSubmissionStartDate!=='1000-01-01'">
                                    <strong class="d-block txt-black">
                                        <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>
                                            {{ c_d.bidSubmissionStartDate | date: 'MMM d, y'}}
                                            </span>
                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                            {{ c_d.bidSubmissionStartTime | timeFormat}}
                                        </span>
                                    </strong>
                                    <span class="labels text-muted screen-reader">{{ 'BidSubmissionStartDate' | translate}}
                                    </span>
                                </div>
                                <div class="opening-date font-adjust" *ngIf="c_d.bidSubmissionEndDate!=='1000-01-01'">
                                    <strong class="d-block txt-black">
                                        <span class="me-2 screen-reader"> <i class="bi bi-calendar3 me-1"></i>
                                            {{ c_d.bidSubmissionEndDate | date: 'MMM d, y'}}
                                            </span>
                                        <span class="screen-reader"> <i class="bi bi-clock me-1"></i>
                                            {{ c_d.bidSubmissionEndTime | timeFormat}}
                                        </span>
                                    </strong> 
                                    <span class="labels text-muted screen-reader">{{ 'BidSubmissionEndDate' | translate}}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="table-responsive mb-4 font-adjust">
                            <table class="table table-hover" aria-describedby="corrigTable">
                                <thead>
                                    <tr>
                                        <th class="screen-reader">#</th>
                                        <!-- <th class="screen-reader">{{ 'DocumentType' | translate}}</th> -->
                                        <th class="screen-reader">{{ 'DocumentName' | translate}}</th>
                                        <th class="text-end screen-reader">{{ 'DocumentSize' | translate}}</th>
                                        <th class="text-center screen-reader">{{ 'Download' | translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>

                        <tr *ngFor="let d of Files_(c_d.uploadDocument); let u = index;">
                          
                                <td class="screen-reader">{{ u+1 }}</td>
                                <!-- <td class="screen-reader">{{ d.fileType }}</td> -->
                                <td class="screen-reader">{{ (language=='English') ? htmlTag(d.fileTitle) : htmlTag(d.fileTitleInHindi)}}</td>
                                <td class="text-end screen-reader">
                                    {{ d.selectFIle_details.fileSize }}
                                    <span style="text-transform: uppercase;" *ngIf="checkFileType(d)!==false" [innerHtml]="checkFileType(d).file"></span>
                                    {{d.dtmCreatedOn | date:'MMM d, y'}}
                                </td>
                                <td class="text-center screen-reader"> 
                                        <strong class="d-block">
                                            <a target="_blank" [href]="backend_url+'storage/app/uploads/'+d.selectFIle" title="{{ d.fileType}}" class="text-green"  [download]="d.selectFIle"><span class="me-2"> <i
                                                    class="bi bi-download me-1"></i></span></a>
                                        </strong>
                                        <!-- <span class="labels text-muted">({{ d.selectFIle_details.fileSize }}) </span> -->
                                </td>
                            </tr> 
                                   
                                </tbody>
                            </table>
                        </div>
                </div>

            </div>
                                                    </div>

                                                    <!-- tender details section area - ends -->


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>


<app-footer></app-footer>